import React from 'react';
import './css/head.css';
import { useState } from 'react';

export default function Head() {
  const [active, setActive] = useState('/');

  return (
    // bg-light
    <div className="container head bg-light">
      {/* bg-body-tertiary */}
      {/* fixed-top */}
      <div className="container-fluid ">
        <nav className="d-flex navbar navbar-expand-md">
          {/* style={{ height: '52px' }} */}
          <div className="container-fluid" style={{ height: '52px' }}>
            <a className="navbar-brand" href="/">
              <img
                className="name-logo"
                src="assets/logo4-removebg-preview.png"
                alt="logo"
                // style={{ width: '110px' }}
                // style={{ width: '40%' }}
              />
            </a>
            <button
              className="navbar-toggler ms-auto"
              tabindex="-1"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasNavbar"
              aria-controls="offcanvasNavbar"
              aria-label="Toggle navigation"
            >
              {/* <span className="navbar-toggler-icon "></span> */}
              <i className="fa-solid fa-bars-staggered fa-flip fa-lg"></i>
            </button>

            <div className="navbar">
              <div
                className=" offcanvas offcanvas-end "
                aria-labelledby="offcanvasNavbarLabel"
                aria-controls="offcanvasNavbar"
                id="offcanvasNavbar"
                style={{ width: '50%' }}
              >
                <div className="offcanvas-header">
                  <img
                    src="assets/logo4-removebg-preview.png"
                    alt="logo"
                    // style={{ width: '100px' }}
                    style={{ width: '12vh' }}
                  />
                  {/* X button */}
                  {/* <button
                    type="button"
                    // className="btn-close text-reset"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                    data-bs-target="#offcanvasNav"
                  >
                    
                  </button> */}
                  <i
                    className="fa-solid fa-circle-xmark fa-shake fa-2xl"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                    data-bs-target="#offcanvasNav"
                  ></i>
                </div>
                <div className="offcanvas-body ">
                  <ul
                    className="navbar-nav flex-grow-1"
                    style={{ alignItems: 'center' }}
                  >
                    <li className="nav-item">
                      <a
                        onClick={() => {
                          setActive('/');
                        }}
                        className={`nav-link ${active === '/' ? 'active' : ''}`}
                        aria-current="page"
                        href="/"
                      >
                        Home
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        onClick={() => {
                          setActive('/about');
                        }}
                        className={`nav-link ${
                          active === '/about' ? 'active' : ''
                        }`}
                        href="#about"
                      >
                        About
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        onClick={() => {
                          setActive('/skills');
                        }}
                        className={`nav-link ${
                          active === '/skills' ? 'active' : ''
                        }`}
                        href="#skills"
                      >
                        Skills
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        onClick={() => {
                          setActive('/projects');
                        }}
                        className={`nav-link ${
                          active === '/projects' ? 'active' : ''
                        }`}
                        href="#project"
                      >
                        Projects
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        onClick={() => {
                          setActive('/research');
                        }}
                        className={`nav-link ${
                          active === '/research' ? 'active' : ''
                        }`}
                        href="#research"
                      >
                        Research
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        onClick={() => {
                          setActive('/contact');
                        }}
                        className={`nav-link ${
                          active === '/contact' ? 'active' : ''
                        }`}
                        href="#contact"
                      >
                        Contact
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
}
